module.exports = __webpack_public_path__ + "img/referto-5.fb5ddd92.jpg";